module.exports = __webpack_public_path__ + "img/datav-workspace.66acbd1d.png";